const prefix = 'BCZ-COPPER'

const storage = {
  // @ts-ignore
  setItem: (key, value) => {
    console.log('set', key, value)
    if (!key.replace(/\s/g)) return
    const _key = storage.getPrefix(key)
    try {
      localStorage.setItem(_key, JSON.stringify(value))
    } catch (e) {
      console.log('保存失败 -----------')
    }
  },
  // @ts-ignore
  getItem: key => {
    console.log('get -----------', key)
    try {
      const _key = storage.getPrefix(key)
      const value = JSON.parse(localStorage.getItem(_key))
      return value
    } catch (e) {
      console.log('读取失败 -----------')
    }
  },
  // @ts-ignore
  removeItem: key => {
    const _key = storage.getPrefix(key)
    localStorage.removeItem(storage.getPrefix(_key))
  },

  clear: () => {
    localStorage.clear()
  },
  // @ts-ignore
  getPrefix: key => {
    return `${prefix}-${key}`
  },
}
export default storage
